import { render } from "./RoutingMachine.vue?vue&type=template&id=015fd08c&scoped=true"
import script from "./RoutingMachine.vue?vue&type=script&lang=js"
export * from "./RoutingMachine.vue?vue&type=script&lang=js"

import "./RoutingMachine.vue?vue&type=style&index=0&id=015fd08c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015fd08c"]])

export default __exports__